// extracted by mini-css-extract-plugin
export default {"businessCard":"BusinessCard_businessCard__ajPlK"};